import React, { useMemo, useRef, useState } from 'react';
import {
  EmptyMemberColor,
  FileDefaultColor,
  FileSkpColor,
  Delete,
  FileRfaColor,
  FileZipColor,
  FileRteColor,
  FileGltfColor,
  FileGlbColor,
} from 'patternx-svg';
import UploadBtn from './upload_btn';
import classNames from 'classnames';
import UploadList from '@/components/upload-list';
import { FileType } from '.';
import { Alert, message, Modal, Tree } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { getUUID } from '@/utils/utils';
import classnames from 'classnames';
import './index.less';
import { getMapTree } from '../../utils';
import CustomEmpty from '@/components/custom-empty';
import { groupBy } from 'lodash-es';

interface IStateStep {
  files: FileType[];
  setFiles: (v: any) => void;
  tagList: any[];
  type: string;
}

let validateCount: number = 0;
export default React.memo((props: IStateStep) => {
  const { files, setFiles, tagList, type } = props;

  const [visibleLabelTree, setVisibleLabelTree] = useState<boolean>(false);
  const uploadRef = useRef<{
    selectFile: () => void;
    selectDirectory: () => void;
  }>();

  // 上传成功
  const onUploadSuccess = (upfiles: any[]) => {
    // console.log(upfiles, 1111);
    const existFileIds = upfiles.filter((file) => file.existFileId).map((file) => file.existFileId);
    const gmodelerFiles = upfiles?.filter((f) => f.fileType === 'gmodeler');
    const otherFiles = upfiles?.filter((f) => f.fileType !== 'gmodeler');
    const elements: any[] = [];
    const groups = groupBy(gmodelerFiles, 'folderPath');
    for (let k in groups) {
      //再次判断是否正向构件还是普通构件
      const glbs = groups[k]?.filter((f) => f.fileSuffix?.toLowerCase() === 'glb') || [];
      const jsonFile = groups[k]?.find(
        (f) => f.fileName?.toLowerCase() === 'meta' && f.fileSuffix?.toLowerCase() === 'json',
      );
      let fileType = '';
      if (glbs?.length === 1 && jsonFile) {
        fileType = 'gmodeler';
      }
      const elementName = jsonFile?.folderName;

      if (!elements?.find((ele) => ele.fileName === elementName)) {
        elements.push({
          fileName: elementName,
          path: k,
          childs: groups[k],
          fileType,
          uid: `new-file-${getUUID()}`,
          name: elementName,
          isAllowSetting: jsonFile?.isAllowSetting,
          adsorptionCategory: jsonFile.isHasReference ? 'custom' : undefined,
        });
      }
    }
    console.log(elements, '================elements', otherFiles);
    setFiles((prevState: FileType[]) => [
      // ...upfiles.map((file) => ({ ...file, uid: `new-file-${getUUID()}` })),
      ...elements,
      ...otherFiles,
      ...prevState.filter((file) => existFileIds.indexOf(file.uid) === -1),
    ]);
  };

  // 判断重名并选择是否替换
  const verifyName = async (file: any) => {
    const fileName = file.name;
    const existFileId = files.find((f) => `${f.fileName}.${f.fileSuffix}` === fileName)?.uid;

    return new Promise<boolean>((resolve) => {
      if (existFileId) {
        Modal.confirm({
          title: `覆盖上传吗？`,
          content: `文件 ${fileName} 与已传文件重名，是否替换已有文件覆盖上传？`,
          icon: <ExclamationCircleOutlined />,
          okText: '是',
          cancelText: '否',
          onCancel: () => resolve(false),
          onOk: () => {
            file.existFileId = existFileId;
            resolve(true);
          },
        });
      } else {
        resolve(true);
      }
    });
  };

  // 校验
  const onValidate = async (file: any, allfiles: any) => {
    if (type === 'gmodeler') {
      return true;
    }
    const fileName = (file?.name || '')?.toLowerCase();
    if (
      !fileName.endsWith('.rfa') &&
      !fileName.endsWith('.skp') &&
      !fileName.endsWith('.gltf') &&
      !fileName.endsWith('.glb') &&
      !fileName.endsWith('.zip') &&
      !fileName.endsWith('.max')
    ) {
      return false;
    }

    const rfaFiles = allfiles.filter(
      (f: { name: string }) =>
        f.name?.toLowerCase()?.endsWith('.rfa') ||
        f.name?.toLowerCase()?.endsWith('.skp') ||
        f.name?.toLowerCase()?.endsWith('.gltf') ||
        f.name?.toLowerCase()?.endsWith('.glb') ||
        f.name?.toLowerCase()?.endsWith('.zip') ||
        f.name?.toLowerCase()?.endsWith('.max'),
    );
    validateCount += 1;
    // 超过500条不能上传
    // console.log('rfafiles = ', rfaFiles);
    // console.log('allfiles = ', allfiles);
    if (rfaFiles.length > 500) {
      if (validateCount === 1) message.error('最多上传500个文件，单个不超过5GB');
      if (validateCount === rfaFiles.length) validateCount = 0;
      return false;
    }

    if (validateCount === rfaFiles.length) validateCount = 0;

    const size = (file?.size || 0) / 1024 / 1024;
    if (size > 5120) {
      message.error('最多上传500个文件，单个不超过5G');
      return false;
    }

    const result = await verifyName(file);
    return result;
  };

  // 上传文件
  const handleMenuClick = ({ key }: any) => {
    if (key === 'file') {
      uploadRef?.current?.selectFile();
    } else {
      uploadRef?.current?.selectDirectory();
    }
  };

  const _handlerRemove = (index: number) => {
    setFiles((state: any) => [...state.slice(0, index), ...state.slice(index + 1)]);
  };

  const renderFileIcon = (file: any) => {
    const name = (file.fileSuffix ?? file.name)?.toLowerCase();
    if (name.endsWith('rfa')) {
      return <FileRfaColor size={40} />;
    }
    if (name.endsWith('skp')) {
      return <FileSkpColor size={40} />;
    }
    if (name.endsWith('glb')) {
      return <FileGlbColor size={40} />;
    }
    if (name.endsWith('zip')) {
      return <FileZipColor size={40} />;
    }
    if (name.endsWith('rte')) {
      return <FileSkpColor size={40} />;
    }
    if (name.endsWith('gltf')) {
      return <FileGltfColor size={40} />;
    }
    return <FileDefaultColor size={40} />;
  };

  const tagTreeList: { key: string; title: string; children: any[] }[] = useMemo(
    () =>
      getMapTree(tagList) as {
        key: string;
        title: string;
        children: any[];
      }[],
    [tagList],
  );

  return (
    <>
      <div className="mt20 mb20">
        <Alert
          message={
            type === 'gmodeler' ? (
              <span className="text-grey-7-14">
                上传正向非参数化部品和正向参数化族文件，需包含json文件
              </span>
            ) : (
              <span className="text-grey-7-14">
                通过文件夹批量上传的本地文件结构需与
                <a className="text-blue-7-14" onClick={() => setVisibleLabelTree(true)}>
                  构件标签
                </a>
                对应
              </span>
            )
          }
          type="info"
          showIcon
        />
      </div>

      {files.length == 0 ? (
        <div className={classNames('empty')}>
          <EmptyMemberColor width={160} />
          <span className="tips mb10">
            {type === 'gmodeler'
              ? '请上传含.json文件的文件夹或.zip压缩包'
              : '请上传.rfa,.skp,.gltf,.glb文件或含.max文件和材质的.zip压缩包'}
          </span>
          <UploadBtn key="1" menuClick={handleMenuClick} />
        </div>
      ) : (
        <div className="uploadBox">
          <div className="upbtn">
            <UploadBtn key="2" menuClick={handleMenuClick} />
          </div>
          <div className="fileBox">
            {files.map((file, index) => {
              return (
                <div className="fileItem" key={file.storageFileId || file.uid}>
                  {renderFileIcon(file)}
                  <div className="fileDetail" title={file.name || file.fileName}>
                    <span className="text-grey-7-14">{file.name || file.fileName}</span>
                    <span
                      className={classnames('fileSize', {
                        hide: !file.fileSize,
                      })}
                    >
                      {(file.fileSize / 1024 / 1024).toFixed(2)}M
                    </span>
                  </div>
                  <Delete
                    size={16}
                    onClick={() => {
                      _handlerRemove(index);
                    }}
                  />
                </div>
              );
            })}
          </div>
        </div>
      )}

      <UploadList
        appName="boss"
        ref={uploadRef}
        uploadUrl="/boss/api/v1/component/public/file:upload"
        onUploadSuccess={onUploadSuccess}
        validate={onValidate}
        accept={type === 'gmodeler' ? '.zip' : '.rfa,.skp,.gltf,.glb,.max,.zip'}
        fileFields={['md5', 'existFileId']}
        isGmodeler={type === 'gmodeler'}
      />

      <Modal
        title="构件标签"
        onCancel={() => setVisibleLabelTree(false)}
        visible={visibleLabelTree}
        width={480}
        maskClosable={false}
        bodyStyle={{
          overflow: 'auto',
          height: 444,
          padding: 24,
        }}
        footer={null}
      >
        <div>
          {tagTreeList.length ? (
            <Tree treeData={tagTreeList} defaultExpandedKeys={[tagTreeList[0]?.key]} />
          ) : (
            <div style={{ marginTop: 120 }}>
              <CustomEmpty />
            </div>
          )}
        </div>
      </Modal>
    </>
  );
});
